export { default as PlaceholderIcon } from "./PlaceholderIcon";
